var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "alert alert-success" }, [
      _c("h3", [_vm._v("Dziękujemy bardzo za wiadomość.")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n      Zgłoszenie zostało zarejestrowane pod numerem\n      "),
        _c("strong", [_vm._v(_vm._s(_vm.data.formNumber))]),
        _vm._v(".\n      "),
        _c("br"),
        _vm._v(
          "Podczas kontaktu z nami prosimy powołać się na ten numer.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Dodatkowo informujemy, że informację dotyczącą numeru i treści zgłoszenia przesłaliśmy na adres e-mail wskazany przez Pana/Panią w formularzu."
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.data.pdfUrl
        ? _c(
            "a",
            {
              staticClass: "btn btn-primary pull-left",
              attrs: { href: _vm.data.pdfUrl, target: "_blank" },
            },
            [
              _vm._v(_vm._s(_vm.$t("btn_label_pdf")) + " "),
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(" otwiera się w nowej karcie"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary pull-right",
          attrs: { type: "button" },
          on: { click: _vm.reload },
        },
        [_vm._v(_vm._s(_vm.$t("btn_label_close")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }